import React, { FunctionComponent } from 'react';
import { Title } from '@gje/typography/lib';
import ReactTooltip from 'react-tooltip';
import { Text } from '@gje/typography/lib';
import classNames from 'classnames';
import { HtmlPanel } from '../HtmlPanel/HtmlPanel';
import {
    isOkq8,
    isVillaagarna
} from '../../../services/partners/partnersService';

interface Props {
    helpText: string;
    header?: string;
    id: string;
    isMobile?: boolean;
    place?: string;
    useGreen?: boolean;
    iconClassName?: string;
    isHidden?: boolean;
    useBlue?: boolean;
    event?: string;
}

const greenQuestionMark = require('../../../images/green-questionmark.png');
const blueQuestionMark = require('../../../images/blue-questionmark.png');

const HelpBox: FunctionComponent<Props> = ({
    header,
    helpText,
    id,
    isMobile,
    place,
    useGreen,
    iconClassName,
    isHidden,
    useBlue,
    event
}) => {
    const tooltipClassNameResolver = () => {
        if (isVillaagarna()) {
            return 'villaagarna-tooltip-theme align-left top-element';
        } else if (isOkq8()) {
            return 'okq8-tooltip-theme align-left top-element';
        } else return 'tooltip-theme align-left top-element';
    };

    return (
        <div
            className={classNames('helpBox', { 'okq8-blue-color': isOkq8() })}
            id={id + 'Parent'}>
            {header && (
                <Title className="help-text-btn" tag={'h6'}>
                    {header}
                </Title>
            )}
            <a
                data-tip={true}
                data-for={id}
                className={isHidden && 'hidden-element'}>
                {useGreen ? (
                    <img
                        className={classNames(
                            'position-inherit',
                            isMobile ? 'mobile-help-icon' : 'help-icon-margins',
                            iconClassName
                        )}
                        src={greenQuestionMark}
                        alt="greenQM"
                    />
                ) : useBlue ? (
                    <img
                        className={classNames(
                            'position-inherit',
                            isMobile ? 'mobile-help-icon' : 'help-icon-margins',
                            iconClassName
                        )}
                        src={blueQuestionMark}
                        alt="blueQM"
                    />
                ) : (
                    <span
                        className={classNames(
                            'gj-icon',
                            'gj-icon-help-open',
                            'position-inherit',
                            isMobile ? 'mobile-help-icon' : 'help-icon-margins',
                            iconClassName
                        )}
                    />
                )}
            </a>
            <ReactTooltip
                className={tooltipClassNameResolver()}
                place={place ? place : 'right'}
                effect="solid"
                id={id}
                event={event ? event : 'click'}
                globalEventOff={'click'}>
                <Text size={'h6'}>
                    <HtmlPanel>{helpText}</HtmlPanel>
                </Text>
            </ReactTooltip>
        </div>
    );
};

export default HelpBox;
